<template>
  <div class="module-kpi" :class="`module-kpi--${item.trendState || 'current'}`">
    <div class="module-kpi-content">
      <div class="module-kpi-main">
        <span class="module-kpi-label">{{ item.label }}</span>
        <strong class="module-kpi-value">{{ item.value }}</strong>
      </div>
      <span
        v-if="item.comparison"
        class="module-kpi-trend"
        :class="`module-kpi-trend--${item.trendState}`"
        :aria-label="item.accessibleTrend"
      >
        <strong>{{ item.trendLabel }}</strong>
        <small>{{ item.deltaLabel }}</small>
        <i
          class="fas module-kpi-direction"
          :class="directionIcon"
          aria-hidden="true"
        ></i>
      </span>
      <span v-else class="module-kpi-current">Valeur actuelle</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardKpiCard',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    directionIcon() {
      if (this.item.trendState === 'down') return 'fa-arrow-down';
      if (this.item.trendState === 'stable') return 'fa-arrow-right';

      return 'fa-arrow-up';
    },
  },
};
</script>

<style scoped>
.module-kpi {
  background: #ffffff;
  border: 1px solid rgba(33, 37, 41, 0.08);
  border-radius: 8px;
  box-shadow: 0 0.35rem 1rem rgba(15, 23, 42, 0.04);
  display: flex;
  flex-direction: column;
  min-height: 108px;
  overflow: hidden;
  padding: 0.7rem 0.85rem;
}

.module-kpi-content {
  align-items: flex-start;
  display: flex;
  gap: 0.5rem;
  justify-content: space-between;
  min-height: 100%;
}

.module-kpi-main {
  display: flex;
  flex-direction: column;
  gap: 0.18rem;
  min-width: 0;
}

.module-kpi-label {
  color: #6c757d;
  font-size: 0.76rem;
  font-weight: 700;
}

.module-kpi-value {
  color: #212529;
  font-size: 1rem;
}

.module-kpi-trend {
  align-items: flex-end;
  display: inline-flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 0.12rem;
  line-height: 1.1;
}

.module-kpi-trend strong {
  font-size: 0.72rem;
}

.module-kpi-trend small,
.module-kpi-current {
  font-size: 0.62rem;
  font-weight: 700;
}

.module-kpi-current {
  color: #94a3b8;
  white-space: nowrap;
}

.module-kpi-trend--up { color: #198754; }
.module-kpi-trend--down { color: #dc3545; }
.module-kpi-trend--stable { color: #6c757d; }

.module-kpi-direction {
  font-size: 1.05rem;
  margin-top: 0.18rem;
}
</style>
